import React from 'react'
import { useAppDispatch, useAppSelector } from './useReduxHooks'
import { shallowEqual } from 'react-redux'
import {
  FetchNoficationsRequest,
  UpdateNotificationsRequest,
  FetchNotificationsCountRequest,
  MarkAllNotificationsReadRequest,
  DeleteNotificationRequest,
} from '../redux/reducers/notifications/types'
import * as actions from '../redux/reducers/notifications/service'

const useNotifications = () => {
  const dispatch = useAppDispatch()
  const { notifications, listLoading, unreadCount: unreadCountFromState } = useAppSelector((state) => state.notifications, shallowEqual)
  const derivedUnread = React.useMemo(
    () => notifications.filter((n) => !n.read).length,
    [notifications]
  )
  const unreadNotificationCount = unreadCountFromState ?? derivedUnread

  const fetchNotifications = (vals: FetchNoficationsRequest) => {
    return dispatch(actions.fetchNotifications(vals))
  }

  /** GET /api/notifications/count — unread count for badge (lighter than full list) */
  const fetchNotificationsCount = (payload?: FetchNotificationsCountRequest) => {
    return dispatch(actions.fetchNotificationsCount(payload ?? {}))
  }

  const handleUnseenNotification = async (payload: UpdateNotificationsRequest) => {
    return dispatch(actions.updateNotification({ notificationId: payload.notificationId }))
  }

  /** Mark all as read: POST /api/notifications/mark-all-read; fallback to N×POST /seen if 404 */
  const markAllAsRead = async (recipient: string) => {
    const result = await dispatch(actions.markAllNotificationsRead({ recipient }))
    if (actions.markAllNotificationsRead.rejected.match(result)) {
      const unreadIds = notifications.filter((n) => !n.read).map((n) => n._id)
      if (unreadIds.length > 0) {
        await Promise.all(
          unreadIds.map((notificationId) =>
            dispatch(actions.updateNotification({ notificationId }))
          )
        )
      }
    }
    await dispatch(actions.fetchNotifications({ recipient }))
  }

  /** Soft-delete one notification: DELETE /api/notifications/:id */
  const deleteNotificationById = (payload: DeleteNotificationRequest) => {
    return dispatch(actions.deleteNotification(payload))
  }

  const handeOpenNotification = () => {}

  return {
    notifications,
    listLoading,
    fetchNotifications,
    fetchNotificationsCount,
    unreadNotificationCount,
    handleUnseenNotification,
    markAllAsRead,
    deleteNotificationById,
    handeOpenNotification,
  }
}

export default useNotifications
